import Experience from '../Experience'

export default class Panels {

    domElements = {
        triggers: document.querySelectorAll('[data-panel]'),
        panels: document.querySelectorAll('.works-panel'),
        contactTriggers: document.querySelectorAll('[data-panel-contact]'),
        contactButton: document.getElementById('works-contact-button'),
        pressFilters: document.querySelectorAll('[data-press-filter]'),
        copyButtons: document.querySelectorAll('[data-copy]'),
    }

    constructor() {
        this.experience = new Experience()
        this.sounds = this.experience.sounds

        this.addEventListeners()

    }

    addEventListeners() {
        this.domElements.triggers.forEach((trigger) => {
            trigger.addEventListener('click', () => this.open(document.getElementById(trigger.dataset.panel)))
        })

        this.domElements.panels.forEach((panel) => {
            panel.querySelector('.works-panel-close').addEventListener('click', () => this.close(panel))

            //Click on the backdrop closes the panel
            panel.addEventListener('click', (event) => {
                if (event.target === panel) this.close(panel)
            })
        })

        this.domElements.contactTriggers.forEach((trigger) => {
            trigger.addEventListener('click', () => {
                this.close(trigger.closest('.works-panel'))
                this.domElements.contactButton.click()
            })
        })

        this.domElements.pressFilters.forEach((button) => {
            button.addEventListener('click', () => this.filterPress(button.dataset.pressFilter))
        })

        this.domElements.copyButtons.forEach((button) => {
            button.addEventListener('click', () => this.copy(button))
        })
    }

    filterPress(type) {
        this.domElements.pressFilters.forEach((button) => {
            button.setAttribute('aria-pressed', String(button.dataset.pressFilter === type))
        })

        document.querySelectorAll('#press-panel .press-year').forEach((year) => {
            let visible = 0
            year.querySelectorAll('.press-item').forEach((item) => {
                const show = type === 'all' || item.dataset.type === type
                item.hidden = !show
                if (show) visible++
            })
            year.hidden = visible === 0
        })
    }

    copy(button) {
        const target = document.getElementById(button.dataset.copy)
        if (!target) return

        const text = Array.from(target.querySelectorAll('p')).map((paragraph) => paragraph.textContent.trim()).join('\n\n')
        const done = () => {
            const label = button.dataset.label || button.textContent
            button.dataset.label = label
            button.textContent = button.dataset.copied
            button.classList.add('is-copied')
            clearTimeout(button.copyTimeout)
            button.copyTimeout = setTimeout(() => {
                button.textContent = label
                button.classList.remove('is-copied')
            }, 1800)
        }

        if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(text).then(done, () => this.copyFallback(target, done))
        } else {
            this.copyFallback(target, done)
        }
    }

    copyFallback(target, done) {
        const selection = window.getSelection()
        const range = document.createRange()
        range.selectNodeContents(target)
        selection.removeAllRanges()
        selection.addRange(range)
        if (document.execCommand('copy')) done()
    }

    open(panel) {
        if (!panel || panel.open) return

        this.sounds.play('buttonClick')
        panel.showModal()
        panel.querySelector('.works-panel-body').scrollTop = 0
    }

    close(panel) {
        if (!panel || !panel.open) return

        panel.close()
    }
}
